export default __webpack_public_path__ + "img/rank2tabs-b80293ae.png";